// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zWjK","delete":"styles_delete__1-wLC","update":"styles_update__2EuB4","add":"styles_add__xHSdU"};